import { readonly, ref } from 'vue';
// helper
import ConfigManager from '@/config/ConfigManager';
import CacheHelper from '@/helper/CacheHelper';
// language
import { th } from '@/helper/locale/th.1054.js';
import { en } from '@/helper/locale/en.1033.js';

const KEY_COOKIE_LOCALE = 'BzbsLocale';

const cache = new CacheHelper(ConfigManager.getCacheType());
const defaultLocale = 1054;
const language = {
    1054: {
        code: 1054,
        short: 'th'
    },
    1033: {
        code: 1033,
        short: 'en'
    }
};

const lbl = ref(en);
const localeCode = ref(1033);

const getters = {
    getLbl: function () {
        return (localeCode.value == 1033) ? en : th;
    },
    getLocale: function () {
        let locale = cache.getCache(KEY_COOKIE_LOCALE);
        if (locale == null) {
            locale = language[defaultLocale];
        }

        return locale;
    },
    getLocaleCode: function () {
        return localeCode.value;
    }
};

const setters = {
    setLocale: function (code) {
        let locale = null;
        if (code) {
            locale = language[code]
        } else {
            const cacheLocale = getters.getLocale();
            locale = cacheLocale;
        }

        localeCode.value = locale.code;
        lbl.value = getters.getLbl();

        cache.setCache(KEY_COOKIE_LOCALE, locale);
    }
};

export default function LocaleStore () {
    setters.setLocale();

    return {
        lbl: readonly(lbl),
        localeCode: readonly(localeCode),
        getters,
        setters
    }
}
